import axios from 'axios'
import {
  getTimestamp,
  MSG
} from './utils';
const DOMAIN = 'https://wenjuan.58.com';

const uploadApi = {
  uploadInfo: DOMAIN + '/s/upload/info',
  uploadToken: DOMAIN + '/s/upload/get_token'
}
axios.defaults.timeout = 30000;
const uploadFile = async (filename, file) => {
  try {
    let res = await axios.get(uploadApi.uploadInfo);
    let {
      code,
      message,
      data
    } = res.data;
    if (code == 1) {
      const {
        appkey,
        secretId,
        bucket,
        url
      } = JSON.parse(data);
      let res = await axios.get(uploadApi.uploadToken, {
        params: {
          bucket: bucket,
          filename: filename
        }
      });
      const cos = new window.WosSys({
        appid: appkey,
        bucket,
        wosurl: 'https://' + url,
        getAppSign: callback => {
          callback(encodeURIComponent(res.data.data));
        }
      });
      return new Promise((resolve, reject) => {
        cos.uploadFile(
          success => {
            const {
              code,
              data: {
                access_url,
                url
              },
              message
            } = JSON.parse(success);
            return resolve(url)
          },
          error => {
            MSG.error('失败！错误原因：' + error.toString())
          },
          propgress => {
            let persentage = parseInt(propgress * 100);

          },
          bucket,
          filename,
          file,
          0
        );
      });
    }
  } catch (error) {
    MSG.error('失败！错误原因：' + error.toString())
  }
}

export default function (files, uploadFileType, size) {
  let file = files[0]
  if (files !== void 0 && files.length > 0) {
    let filename = file.name
    let index = filename.lastIndexOf('.')
    let result = filename.slice(index + 1)
    let _filename = filename.slice(0, index);
    if (!!result && uploadFileType.indexOf(result) === -1) {
      MSG.warning('请上传规定格式的文件')
    } else if (file.size / (1024 * 1024) > size) {
      MSG.warning(`上传文件不能超过${size}M`)
    } else {
      _filename = _filename + '_' + getTimestamp() + '.' + result;
      return uploadFile(_filename, file);
    }
  } else {
    MSG.warning('请选择文件')
  }
}



// WEBPACK FOOTER //
// ./src/utils/uploadFile.js